import { useState } from 'react';

import { useAdminAuditQuery } from '@/client/api/admin/audit.query';
import DataTable from '../components/DataTable';

const fmtDate = (v?: string | null) => (v ? new Date(v).toLocaleString() : '—');

const clean = (v?: string | null) => {
  const s = (v ?? '').trim();
  return s && s.toLowerCase() !== 'unknown' ? s : '';
};

const AuditTab = ({ uid, authid }: { uid: number; authid: string | null }) => {
  const [mode, setMode] = useState<'by' | 'on'>('by');
  const { data, isLoading } = useAdminAuditQuery(
    mode === 'by'
      ? { actor_authid: authid ?? undefined, limit: 100 }
      : { target_type: 'user', target_id: uid, limit: 100 }
  );
  const actions = data?.actions ?? [];

  return (
    <div className="space-y-3">
      <div className="inline-flex rounded-md border border-gray-200 bg-white p-0.5 text-sm">
        <button
          type="button"
          onClick={() => setMode('by')}
          className={`rounded px-3 py-1 font-medium ${mode === 'by' ? 'bg-blue-600 text-white' : 'text-gray-600'}`}
        >
          Actions by user
        </button>
        <button
          type="button"
          onClick={() => setMode('on')}
          className={`rounded px-3 py-1 font-medium ${mode === 'on' ? 'bg-blue-600 text-white' : 'text-gray-600'}`}
        >
          Actions on user
        </button>
      </div>

      <DataTable
        loading={isLoading}
        rows={actions}
        keyFn={a => `${a.timestamp}-${a.action}-${a.target_id}`}
        emptyLabel={
          mode === 'by' && !authid ? 'No authid resolved for this user.' : 'No audit entries.'
        }
        columns={[
          { header: 'When', cell: a => fmtDate(a.timestamp) },
          { header: 'Action', cell: a => a.action },
          { header: 'Target', cell: a => `${a.target_type} ${a.target_id}` },
          {
            header: 'Actor',
            cell: a => {
              const name = [clean(a.actor?.first_name), clean(a.actor?.last_name)]
                .filter(Boolean)
                .join(' ');
              const email = clean(a.actor?.email);
              const fallback = a.actor_uid != null ? `uid ${a.actor_uid}` : '—';
              return (
                <div>
                  <div className="text-sm text-gray-900">{name || fallback}</div>
                  {email && <div className="text-xs text-gray-500">{email}</div>}
                </div>
              );
            },
          },
        ]}
      />
    </div>
  );
};

export default AuditTab;
